// extracted by mini-css-extract-plugin
export default {"errorIconWrapper":"ErrorIcon-module--error-icon-wrapper--0e38d"};